import BankAccountCard from './BankAccountCard';
import styles from './bank-account.module.scss';
import { Suspense, useContext, useEffect } from 'react';
import WidgetLoader from '../../../../atoms/widget-loader/WidgetLoader';
import WidgetError from '../../../../atoms/widget-error/WidgetError';
import { useQuery } from '@tanstack/react-query';
import { getBankAccounts } from 'bff/hooks/reporting/BankAccountsApi';
import { WidgetContext } from 'modules/dashboard/components/organisms/widget/Widget';
import { useSetWidgetQueryStatus } from 'modules/dashboard/types/widgets/widget.hooks';
import bankLogo from 'modules/dashboard/utils/shared/bankAccountLogos';

const BankAccountsWidget = () => {
  const context = useContext(WidgetContext);

  const {
    data: bankAccountData,
    isFetching,
    isError,
    refetch,
    isSuccess
  } = useQuery(getBankAccounts({ clientId: 1 }));

  useEffect(() => {
    if (!context) return;
    context.setReloadHandler(() => () => {
      refetch();
    });
  }, []);

  useSetWidgetQueryStatus({ isFetching, isError, isSuccess, context });

  return (
    <Suspense fallback={<WidgetLoader />}>
      {isFetching ? (
        <div className={styles.container}>
          <WidgetLoader />
        </div>
      ) : isError ? (
        <WidgetError onRefresh={refetch} isRefreshing={isFetching} />
      ) : (
        <div className={styles.banksContainer}>
          {bankAccountData?.bankAccountsList.map((account) => (
            <BankAccountCard
              key={account.accountNumber}
              logo={bankLogo(account.bankName ? account.bankName : '')}
              bankName={account.bankName ? account.bankName : ''}
              accountHolder={account.accountHolderName ? account.accountHolderName : ''}
              accountNumber={account.accountNumber ? account.accountNumber : ''}
              accountType={account.accountType ? account.accountType : ''}
              verified={account.verifiedStatus ? account.verifiedStatus : false}
            />
          ))}
        </div>
      )}
    </Suspense>
  );
};

export default BankAccountsWidget;
